export enum DocumentPrefix {
  BorrowerW2 = 'borrower_w2',
  BorrowerPayStubs = 'borrower_most_recent_pay_stubs',
  Borrower2ndMostRecentPayStubs = 'borrower_2nd_most_recent_pay_stubs',
  BorrowerPersonalTaxReturns = 'borrower_most_recent_personal_tax_returns',
  Borrower2ndMostRecentPersonalTaxReturns = 'borrower_2nd_most_recent_personal_tax_returns',
  BorrowerBusinessTaxReturns = 'borrower_most_recent_business_tax_returns',
  Borrower2ndMostRecentBusinessTaxReturns = 'borrower_2nd_most_recent_business_tax_returns',
  BorrowerVADisabilityAwardsLetter = 'borrower_va_disability_awards_letter',
  BorrowerMilitaryPensionAwardsLetter = 'borrower_military_pension_awards_letter',
  BorrowerSocialSecurityAwardsLetter = 'borrower_social_security_awards_letter',
  BorrowerEmployerPensionLetter = 'borrower_employer_pension_letter',
  BorrowerRentalOrLeaseAgreement = 'borrower_rental_or_lease_agreement',
  Borrower1099 = 'borrower_1099',
  BorrowerProfitAndLoss = 'borrower_profit_and_loss',
  BorrowerTaxReturnExtension = 'borrower_tax_return_extension',
  BorrowerDriversLicense = 'borrower_drivers_license',
  BorrowerPassport = 'borrower_passport',
  BorrowerSocialSecurityCard = 'borrower_social_security_card',
  BorrowerGreenCard = 'borrower_green_card',
  BorrowerMonthlyMortgageStatement = 'borrower_monthly_mortgage_statement',
  BorrowerClosingDisclosure = 'borrower_closing_disclosure',
  BorrowerDeed = 'borrower_deed',
  BorrowerUtilityBill = 'borrower_utility_bill',
  BorrowerHomeImprovementEstimatesOrContracts = 'borrower_home_improvement_estimates_or_contracts',
  BorrowerVoidedCheck = 'borrower_voided_check',
  BorrowerScreenshotOfOnlineBanking = 'borrower_screenshot_of_online_banking',
  BorrowerDirectDepositAuthorizationForm = 'borrower_direct_deposit_authorization_form',
  BorrowerLetterOfExplanation = 'borrower_letter_of_explanation',
  CoborrowerW2 = 'coborrower_w2',
  CoborrowerPayStubs = 'coborrower_most_recent_pay_stubs',
  Coborrower2ndMostRecentPayStubs = 'coborrower_2nd_most_recent_pay_stubs',
  CoborrowerPersonalTaxReturns = 'coborrower_most_recent_personal_tax_returns',
  Coborrower2ndMostRecentPersonalTaxReturns = 'coborrower_2nd_most_recent_personal_tax_returns',
  CoborrowerBusinessTaxReturns = 'coborrower_most_recent_business_tax_returns',
  Coborrower2ndMostRecentBusinessTaxReturns = 'coborrower_2nd_most_recent_business_tax_returns',
  CoborrowerVADisabilityAwardsLetter = 'coborrower_va_disability_awards_letter',
  CoborrowerMilitaryPensionAwardsLetter = 'coborrower_military_pension_awards_letter',
  CoborrowerSocialSecurityAwardsLetter = 'coborrower_social_security_awards_letter',
  CoborrowerEmployerPensionLetter = 'coborrower_employer_pension_letter',
  CoborrowerRentalOrLeaseAgreement = 'coborrower_rental_or_lease_agreement',
  Coborrower1099 = 'coborrower_1099',
  CoborrowerProfitAndLoss = 'coborrower_profit_and_loss',
  CoborrowerTaxReturnExtension = 'coborrower_tax_return_extension',
  CoborrowerDriversLicense = 'coborrower_drivers_license',
  CoborrowerPassport = 'coborrower_passport',
  CoborrowerSocialSecurityCard = 'coborrower_social_security_card',
  CoborrowerGreenCard = 'coborrower_green_card',
  CoborrowerUtilityBill = 'coborrower_utility_bill',
  CoborrowerLetterOfExplanation = 'coborrower_letter_of_explanation',
  OtherDocument1 = 'other_document_1',
  OtherDocument2 = 'other_document_2',
  OtherDocument3 = 'other_document_3',
  OtherDocument4 = 'other_document_4',
  OtherDocument5 = 'other_document_5',
  OtherDocument6 = 'other_document_6',
  OtherDocument7 = 'other_document_7',
  OtherDocument8 = 'other_document_8',
  OtherDocument9 = 'other_document_9',
  OtherDocument10 = 'other_document_10',
  BorrowerOtherIncome1 = 'borrower_other_income_1',
  BorrowerOtherIncome2 = 'borrower_other_income_2',
  BorrowerOtherIncome3 = 'borrower_other_income_3',
  BorrowerOtherIncome4 = 'borrower_other_income_4',
  BorrowerOtherIncome5 = 'borrower_other_income_5',
  BorrowerOtherIncome6 = 'borrower_other_income_6',
  CoborrowerOtherIncome1 = 'coborrower_other_income_1',
  CoborrowerOtherIncome2 = 'coborrower_other_income_2',
  CoborrowerOtherIncome3 = 'coborrower_other_income_3',
  CoborrowerOtherIncome4 = 'coborrower_other_income_4',
  CoborrowerOtherIncome5 = 'coborrower_other_income_5',
  CoborrowerOtherIncome6 = 'coborrower_other_income_6',
  OtherFundingDocument = 'other_funding_document',
  OtherFundingDocument2 = 'other_funding_document_2',
  OtherFundingDocument3 = 'other_funding_document_3',
  OtherContractorDocument = 'other_contractor_document',
  OtherContractorDocument2 = 'other_contractor_document_2',
  OtherContractorDocument3 = 'other_contractor_document_3',
  OtherHomeVerificationDocument = 'other_home_verification_document',
  OtherHomeVerificationDocument2 = 'other_home_verification_document_2',
  OtherHomeVerificationDocument3 = 'other_home_verification_document_3',
  BorrowerMiscOtherDocument1 = 'borrower_misc_other_document_1',
  CoborrowerMiscOtherDocument1 = 'coborrower_misc_other_document_1',
  BorrowerMiscOtherDocument2 = 'borrower_misc_other_document_2',
  CoborrowerMiscOtherDocument2 = 'coborrower_misc_other_document_2',
  BorrowerMiscOtherDocument3 = 'borrower_misc_other_document_3',
  CoborrowerMiscOtherDocument3 = 'coborrower_misc_other_document_3',
  BorrowerBankStatement = 'borrower_bank_statement',
  BorrowerCellPhoneBill = 'borrower_cell_phone_bill',
  CoBorrowerCellPhoneBill = 'coborrower_cell_phone_bill',
}
